import script from "./AdminEmployeesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminEmployeesView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminEmployeesView.vue?vue&type=style&index=0&id=432817e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432817e1"]])

export default __exports__